import { CardContent, Box } from '@mui/material';
import { MinimalCard } from 'components/styled';

import { Typography, Spacer, Avatar, Button, Centered } from './styles';

function Details() {
  return (
    <MinimalCard $hoverEffect={false} sx={{ mb: 6 }}>
      <CardContent>
        <Typography variant="h6" gutterBottom>
          Profile Details
        </Typography>

        <Spacer mb={4} />

        <Centered>
          <Avatar alt="Lucy Lavender" src="/static/img/avatars/avatar-1.jpg" />
          <Typography variant="body2" component="div" gutterBottom>
            <Box fontWeight="fontWeightMedium">Lucy Lavender</Box>
            <Box fontWeight="fontWeightRegular">Lead Developer</Box>
          </Typography>

          <Button sx={{ mr: 2 }} variant="contained" size="small">
            Follow
          </Button>
          <Button sx={{ mr: 2 }} variant="contained" color="primary" size="small">
            Message
          </Button>
        </Centered>
      </CardContent>
    </MinimalCard>
  );
}

export default Details;
